// src/pages/AppDownload.jsx
// Android アプリ (.apk) のダウンロードページ【2026-07-06】
// - apk 情報: GET /api/app/version（要 Bearer）
// - 本体DL:  GET /api/app/download（要 Bearer）→ blob 保存
import React, { useEffect, useState } from 'react';

export default function AppDownload() {
  const [apk, setApk]             = useState(null); // { filename, version, sizeBytes, updatedAt }
  const [loading, setLoading]     = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [err, setErr]             = useState('');
  const [msg, setMsg]             = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch('/api/app/version', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(d => {
        if (d.success) setApk(d.apk);
        else setErr(d.message || 'アプリ情報を取得できませんでした');
      })
      .catch(() => setErr('通信エラーが発生しました'))
      .finally(() => setLoading(false));
  }, []);

  const download = async () => {
    setDownloading(true); setErr(''); setMsg('');
    try {
      const token = localStorage.getItem('token');
      const res   = await fetch('/api/app/download', {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || 'ダウンロードに失敗しました');
      }
      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = apk?.filename || 'app.apk';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      setMsg('ダウンロードを開始しました。Android端末では「提供元不明のアプリ」の許可が必要な場合があります。');
    } catch (e) { setErr(e.message); }
    finally     { setDownloading(false); }
  };

  const fmtSize = (b) => (b / 1024 / 1024).toFixed(1) + ' MB';
  const fmtDate = (iso) => new Date(iso).toLocaleString('ja-JP');

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Android アプリ</h1>
        <p>出席管理アプリ (.apk) をダウンロードできます。Android端末でこのページを開いてください。</p>
      </div>

      <div className="card">
        <div className="card-header"><h2>配布中のアプリ</h2></div>
        {loading && <p>アプリ情報を確認しています...</p>}
        {!loading && apk && (
          <>
            <table style={{ borderCollapse: 'collapse', lineHeight: 2 }}>
              <tbody>
                <tr><td style={{ paddingRight: '1.5rem', color: '#666' }}>ファイル</td><td>{apk.filename}</td></tr>
                {apk.version && (
                  <tr><td style={{ paddingRight: '1.5rem', color: '#666' }}>バージョン</td><td>{apk.version}</td></tr>
                )}
                <tr><td style={{ paddingRight: '1.5rem', color: '#666' }}>サイズ</td><td>{fmtSize(apk.sizeBytes)}</td></tr>
                <tr><td style={{ paddingRight: '1.5rem', color: '#666' }}>更新日</td><td>{fmtDate(apk.updatedAt)}</td></tr>
              </tbody>
            </table>
            <button className="btn-primary" onClick={download} disabled={downloading} style={{ marginTop: '1rem' }}>
              {downloading ? 'ダウンロード中...' : 'ダウンロード'}
            </button>
          </>
        )}
        {!loading && !apk && !err && <p>配布中のアプリはありません。</p>}
      </div>

      {msg && (
        <div className="card" style={{ borderLeft: '4px solid #22c55e' }}>
          <p style={{ color: '#166534' }}>{msg}</p>
        </div>
      )}
      {err && (
        <div className="card" style={{ borderLeft: '4px solid #ef4444' }}>
          <p style={{ color: '#c62828' }}>{err}</p>
        </div>
      )}

      <div className="card" style={{ background: '#f9fafb' }}>
        <div className="card-header"><h2>インストール手順</h2></div>
        <ol style={{ paddingLeft: '1.5rem', lineHeight: 1.9 }}>
          <li>Android端末のブラウザでこのページを開き、「ダウンロード」を押します。</li>
          <li>ダウンロードした .apk を開きます（通知またはファイルアプリから）。</li>
          <li>「提供元不明のアプリ」の警告が出たら、このブラウザからのインストールを許可してください。</li>
          <li>インストール後、アプリにログインして利用開始です。</li>
        </ol>
      </div>
    </div>
  );
}
